// @ts-nocheck: converted from JS

import CreateStudy from '@/components/Studies/Create';

export default CreateStudy;
